import React, { Component } from 'react';
import _ from 'lodash';
import { Table, Pagination, FormControl } from 'react-bootstrap';


// function searchingFor(filterRows){
// 	return function(x){
//       let key = _.keys(filterRows)
//       let newObj =[]
//       if(!_.isEmpty(key)){        
//        _.map(key, (gg) =>{    
//         let val = _.get(x, gg)
//         if(!_.isNull(val) && typeof val !== undefined){
//           if(typeof val === "string"){
//             newObj.push(val.toLowerCase().includes(filterRows[gg].toLowerCase()))
//           } else {
//             newObj.push(val.toString().includes(filterRows[gg].toString()))
//           }
//         }
//       })
//     }
//     if(!_.isEmpty(newObj)){
//       return !_.includes(newObj, false)
//     } else {
//        return true
//     }
//   }
// }
export default class ReportViewParameters extends Component {
  constructor(props){
    super(props)
    this.state= {
      activePage: 1,
      orderBy:"asc",
      showFilter:false,
      filterRows: {}
    }
   }
   UNSAFE_componentWillMount(){
    this.setState({reportData:this.props.reportData})
   }
   UNSAFE_componentWillReceiveProps(nextProps){
    if(!_.isEqual(this.props.reportData, nextProps.reportData)){
      this.setState({reportData:nextProps.reportData})
    }

  }

  handleSelectPagination = (eventKey) => {
    this.setState({
      activePage: eventKey,
    });
	}
	handleSelectPaginationPrev = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage-1,
    });
	}
	handleSelectPaginationNext = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage+1,
    });
  }
  handleSort = (column) => {
    const {orderBy, reportData} = this.state
    let alphaRegex = ".*[A-Z].*";
    var data = _.orderBy(reportData.value, row => {
    let value = _.get(row, column)
    if(!_.isNull(value) && typeof value !== 'undefined'){
      if(value.match(alphaRegex)){
       return value != null ? value.toString().toLowerCase() : ''
      } else {
        return value != null ? parseInt(value) : ''
      }      
      }
   }, orderBy) 
    reportData.value = data
    this.setState({reportData})
    if(orderBy === "asc"){
     this.setState({orderBy:"desc"})
    } else {
     this.setState({orderBy:"asc"})
    }
  }
  
  handleFilter = () =>{
    this.setState((prevState) =>{
      return {showFilter: !prevState.showFilter};
    })
    if(!_.isNull(this.state.filterRows)){
      let keys = _.keys(this.state.filterRows)
      _.map(keys, (obj) =>{
        this.setState({[obj]:""})
      })
      this.setState({filterRows:{}})
    }
  }
  mapDatabodyData = (data, startOffset, startCount, Per_Page, parameterFields, fields, filterfield) =>{
    parameterFields = _.uniqBy(parameterFields)
    let returnObj=[];
    _.map(data.value,  (xx, index)=> {
      if(index >= startOffset & startCount < Per_Page){
        startCount++;          
        returnObj.push(                              
      <tr>
        {_.map(fields, (dd) => {
         let val = dd.value  
          return <td>{_.get(xx, val)}</td>;
        })}
        {_.map(parameterFields, (param, paramIndex) =>{
          let findout = _.find(xx.categories, {"category" : param.category})    
          if(typeof findout !== "undefined"){   
              return <td>{(findout[param.value])}</td>;
            
          }  
         // else {
            // xx.parameterWiseScoreDetList.splice(paramIndex, 0, {"parameterName" : param.label, "totalCount": "",
            // "totalScore": "", "score": ""});
            //   this.setState({reportData:data})
            // }
        }  )}
      </tr>   
      );
    }
  })
 
  if(this.state.showFilter === true){
    returnObj.unshift(<tr>{filterfield}</tr>)
  }
  return returnObj
  }

  handleChange = (e) => {
    const {filterRows} = this.state
    let filterCol = filterRows
    if(_.has(filterCol, e.target.id)){
      filterCol[e.target.id]  = e.target.value
    } else {
      filterCol = Object.assign(filterCol, {[e.target.id]:e.target.value})
    }
    this.setState({[e.target.id]:e.target.value, filterRows:filterCol})	
  }
 
 
  render(){
    const{activePage, reportData} = this.state;    
    const Per_Page=20;
		let totalPages = 1
		const startOffset = (this.state.activePage-1) * Per_Page;
		let startCount = 0;
    let items = [];
    
    if(!_.isEmpty(reportData) && !_.isEmpty(reportData.value)){
      totalPages = Math.ceil(reportData.value.length/Per_Page)
		for (let number = 1; number <= totalPages; number++) {
			items.push(
				<Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
					{number}
				</Pagination.Item>				
			);
      }
    }
  
    let subHeaders=[];
    let fields=[];
    let length=1;   
    let filterfield=[]
    let rowSpan=1
    let parameterFields = []
    return(
    <div className="reportDataView" >
      {  !_.isEmpty(reportData.value) ?
      <div>
        <Table responsive bordered>
        <thead>
        <tr>
          {
            _.map(_.cloneDeep(reportData.header), (obj, index) => {                        
                if(_.has(obj, "subHeaders")){
                  rowSpan=1
                  length = obj.subHeaders.length                  
                _.map(obj.subHeaders, (tt, i) => {   
                 
                  if(_.has(tt, 'category')){
                    parameterFields.push(_.cloneDeep(tt))  
                    let index1 = _.findIndex(reportData.value[0].categories, {"category": tt.category})
                    let newCol = "categories["+index1+"]"+"."+tt.value
                    tt.value = newCol
                    subHeaders.push(_.cloneDeep(tt))
                   }  else {
                    fields.push(tt)
                    subHeaders.push(_.cloneDeep(tt))
                   }
                  filterfield.push(<td><FormControl
                                    placeholder="Search"
                                    aria-label="Search"
                                    aria-describedby="basic-addon1"
                                    id={tt.value}
                                    onChange={(e) => this.handleChange(e)}
                                    value={this.state[tt.value]}
                                    /></td>)   
                })
              } else {
                fields.push(obj)
                rowSpan=2
                filterfield.push(<td><FormControl
                                    placeholder="Search"
                                    aria-label="Search"
                                    aria-describedby="basic-addon1"
                                    id={obj.value}
                                    onChange={(e) => this.handleChange(e)}
                                    value={this.state[obj.value]}
                                    /></td>)   
              }
              return <th colSpan={length} rowSpan={rowSpan}>
              {/* {index === 0 ? <i class="fas fa-filter filterReport" onClick={this.handleFilter}/> : null} */}
              {obj.label.toUpperCase()}&nbsp;
              {/* {_.has(obj, "subHeaders") ? null : <i class="fas fa-sort" onClick={()=>this.handleSort(obj.value)}/>  } */}
              </th>;
            })}
          </tr>
          {(!_.isEmpty(subHeaders))?
          <tr className="dualheaders">            
            {_.map(subHeaders, obj => {
              return <th>{obj.label.toUpperCase()}&nbsp;
              <i class="fas fa-sort" onClick={()=>this.handleSort(obj.value)}/>             
            </th>;
            })}
          </tr> : null }
        </thead>
        <tbody>
      {  !_.isEmpty(reportData.value) ?
        this.mapDatabodyData(reportData, startOffset, startCount, Per_Page, parameterFields, fields, filterfield)   :
          <tr><td colSpan={length}>No Record Found</td></tr>
         }           
           {(_.has(reportData, "grandTotal") && !_.isNull(reportData.grandTotal))  ?
           <tr>
            {_.map(reportData.grandTotal, (obj) => {
              return (
              <td><b>{obj.value}</b></td>
              )
            }) }
          </tr> : null }  
        </tbody>
      </Table>
      <br/>
      <Pagination>
				<Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
				<Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
          {items[activePage-1]}
          {items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
          {items[activePage+1]}
				<Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
				<Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
				</Pagination>
      </div>:
     <Table responsive bordered className='marginTop'><tbody><tr><td>No Records Found</td></tr></tbody></Table>}
    
    
    </div>)
  }
}